export default [0, 1, 2000, 3000, 4000, 5000, 6000, 7000, 8000, 9000, 10000, 11000]
